import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { logger } from 'shared/utils/logger';
import {
  Engine, EngineListItem, EngineDetail, EnginesStateType,
} from '../types/types';
import {
  getEngines, getEngineById, createEngine, updateEngine, deleteEngine,
} from '../actions/actions';

const initialState: EnginesStateType = {
  engineDetail: {
    isLoading: false,
    data: null,
  },
  engines: [],
  isLoading: false,
};

const slice = createSlice({
  name: 'engines',
  initialState,
  reducers: {
    dropDetailData(state: EnginesStateType) {
      state.engineDetail.data = null;
    },
  },
  extraReducers(builder) {
    builder.addCase(getEngines.pending, (state: EnginesStateType) => {
      state.isLoading = true;
    });
    builder.addCase(getEngines.fulfilled, (state: EnginesStateType, action: PayloadAction<EngineListItem[]>) => {
      state.engines = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getEngines.rejected, (state: EnginesStateType, action) => {
      logger.error('engines/getEngines', action.payload);
      state.isLoading = false;
    });

    builder.addCase(getEngineById.pending, (state: EnginesStateType) => {
      state.engineDetail.isLoading = true;
    });
    builder.addCase(getEngineById.fulfilled, (state: EnginesStateType, action: PayloadAction<EngineDetail>) => {
      state.engineDetail.data = action.payload;
      state.engineDetail.isLoading = false;
    });
    builder.addCase(getEngineById.rejected, (state: EnginesStateType, action) => {
      logger.error('engines/getEngineById', action.payload);
      state.engineDetail.isLoading = false;
    });

    // Удалены несуществующие case'ы

    builder.addCase(createEngine.pending, (state: EnginesStateType) => {
      state.engineDetail.isLoading = true;
      state.isLoading = true;
    });
    builder.addCase(createEngine.fulfilled, (state: EnginesStateType) => {
      state.engineDetail.isLoading = false;
      state.isLoading = false;
    });
    builder.addCase(createEngine.rejected, (state: EnginesStateType, action) => {
      logger.error('engines/createEngine', action.payload);
      state.engineDetail.isLoading = false;
      state.isLoading = false;
    });

    builder.addCase(updateEngine.pending, (state: EnginesStateType) => {
      state.engineDetail.isLoading = true;
      state.isLoading = true;
    });
    builder.addCase(updateEngine.fulfilled, (state: EnginesStateType) => {
      state.engineDetail.isLoading = false;
      state.isLoading = false;
    });
    builder.addCase(updateEngine.rejected, (state: EnginesStateType, action) => {
      logger.error('engines/updateEngine', action.payload);
      state.engineDetail.isLoading = false;
      state.isLoading = false;
    });

    builder.addCase(deleteEngine.pending, (state: EnginesStateType) => {
      state.isLoading = true;
    });
    builder.addCase(deleteEngine.fulfilled, (state: EnginesStateType, action: PayloadAction<number>) => {
      state.engines = state.engines.filter((engine) => engine.id !== action.payload);
      state.isLoading = false;
    });
    builder.addCase(deleteEngine.rejected, (state: EnginesStateType, action) => {
      logger.error('engines/deleteEngine', action.payload);
      state.isLoading = false;
    });
  },
});

export const engineActions = slice.actions;
export default slice.reducer;
